import React from "react";
import { useParams } from "react-router-dom";
import { Col, Typography } from "antd";
import CustomRow from "../../../shared/costum-row/costum-row";
import CustomImage from "../../../shared/custom-image/custom-image";
import BlogParagraph from "../../../components/blog-paragraph/blog-paragraph";
import BlogImage from "../../../components/blog-image/blog-image";
import PersonInfo from "../../../components/person-info/person-info";
import useBreakpoints from "../../../hooks/use-breakpoints";
import { BREAKPOINTS } from "../../../constants/styles";
import { getBlogPostById } from "../../../constants/content/pages/blog";

import "./styles.scss";

const { Title, Text } = Typography;

const BlogDetails = () => {
  const { id } = useParams<{ id: string }>();
  const blogPost = getBlogPostById(Number(id));
  const currentBreakpoint = useBreakpoints();

  const isMobile =
    currentBreakpoint === BREAKPOINTS.MOBILE.type ||
    currentBreakpoint === BREAKPOINTS.TABLET.type;

  const isTablet = currentBreakpoint === BREAKPOINTS.TABLET.type;

  const isSmallDesktop = currentBreakpoint === BREAKPOINTS.SMALL_DESKTOP.type;

  const mainGap = isMobile ? 25 : isSmallDesktop || isTablet ? 40 : 80;

  if (!blogPost) {
    return <div>Blog post not found</div>;
  }

  return (
    <div className="BlogDetails">
      <CustomRow justify={"space-between"} gutter={[0, mainGap]} isMarginNone>
        <Col xxl={16} xl={16} lg={10} md={16} sm={24} xs={24}>
          <Title className="BlogDetails-title">
            {blogPost.title}
          </Title>
        </Col>
        <Col xxl={6} xl={6} lg={4} md={6} sm={24} xs={24}>
          <Text className="BlogDetails-description">
            {blogPost.description}
          </Text>
        </Col>
        <Col span={12} className="BlogDetails-topic-container">
          <Text className="BlogDetails-topic">{blogPost.category}</Text>
        </Col>
        <Col span={12} className="BlogDetails-date-container">
          <Text className="BlogDetails-date">{blogPost.date}</Text>
        </Col>
      </CustomRow>
      <CustomImage
        src={blogPost.heroImage}
        className="BlogDetails-image"
      />
      <CustomRow
        justify={"center"}
        align={"middle"}
        className="BlogDetails-content"
      >
        <Col xxl={12} xl={12} lg={20} md={20} sm={24} xs={24}>
          <CustomRow gutter={[0, isMobile ? 40 : mainGap]} justify={"center"}>
            {blogPost.content.paragraphs.map((paragraph, index) => (
              <Col span={24} key={`paragraph-${index}`}>
                <BlogParagraph content={paragraph} />
              </Col>
            ))}
            {blogPost.content.images.map((image, index) => (
              <Col span={24} key={`image-${index}`}>
                <BlogImage src={image.src} text={image.caption} />
              </Col>
            ))}

            <Col>
              <PersonInfo name={blogPost.author} />
            </Col>
          </CustomRow>
        </Col>

        <Col></Col>
      </CustomRow>
    </div>
  );
};

export default BlogDetails;
